/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EmbeddingsGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  OrgId: "org_id",
  Model: "model",
} as const;
export type EmbeddingsGroupBy = ClosedEnum<typeof EmbeddingsGroupBy>;

/** @internal */
export const EmbeddingsGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof EmbeddingsGroupBy
> = z.nativeEnum(EmbeddingsGroupBy);
/** @internal */
export const EmbeddingsGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof EmbeddingsGroupBy
> = EmbeddingsGroupBy$inboundSchema;
